module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/5bec6fcbc21c2e20df1ed0dfd70555d2.png";